module.exports = __webpack_public_path__ + "img/logo.8dd37847.svg";